import React from 'react';
import classes from './Dialer.module.css'

const Dialer = () => {
    const cls = [
        classes.Phone,
        classes.isAnimating
    ];
    return (
            <>
                <i className={cls.join(' ')}></i>
            </>
    );
};
export default Dialer
